import React from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import Image from "@airasia/phoenix-components/components/Image";
import Text from "@airasia/phoenix-components/components/Text";
import Link from "@airasia/phoenix-components/components/Link";
import { fireGtmEvent } from "../utils/functions";
import mobileFeatures_Data from "../data/my/ms/mobileFeatures";

var MobileContainer = styled.div`
  display: flex;
  margin: 1.5em auto;
  text-align: center;

  @media only screen and (max-width: 480px) {
    width: 100%;
    gap: 10px;
    display:block;
  }
`;

var MobileIcons = styled.div`
  margin: 0.8em;
  text-align: center;

  p {
    line-height: 21px;
  }

  @media only screen and (max-width: 480px) {
    width: 100%;
    margin: 0em auto 2em;
  }
`;

const FeaturesIcons = styled.div`
  text-align:center;
  margin:0 auto;

#linkContainer{font-size:0.8rem;}
#icon-image{
  box-shadow: 0 2px 4px 2px #00000015;
  width:50px;
  height:50px;
  padding:5px;
  margin:5px auto;
  text-align:center;
  border-radius:50%;
}

#icon-title{
  line-height:1.2;
  font-size:14px;
  margin-bottom:10px;
  }


@media only screen and (max-width: 768px) {
  #icon-image{
    width:40px;
    margin: 0 auto;
    height:40px;
  }

  #linkContainer{width:25%;}
}`

var BoxIcon = styled.div`
 margin-bottom:15px;
`;

export default function CouponCode() {
  return (
    <MobileContainer>
      <FeaturesIcons>
      {mobileFeatures_Data &&
        mobileFeatures_Data.map((data) => (
          <Link
            accessible
            enableQuantumMetrics={false}
            hoverUnderlined
            href={data.url}
            quantumMetricType=""
            stopPropagation
            target="tab"
            fireGtm={fireGtmEvent}
            gtmEventData={{
              event: "trackEventNoEcommerce",
              eventDetails: {
                category: "aa bigpay",
                action: "click",
                label: `${data.title} icon2 | mobileFeatures Icons`,
              },
            }}
            customProperties={{ id: "linkContainer" }}
            // onClick={() => handleButtonClick(data.title, data.url, data.image)}
          >
            <MobileIcons key={data.title}>
              <BoxIcon>
                <Image
                  accessible
                  width="100%"
                  placeHolderBackground="none"
                  customProperties={{ id: "icon-image" }}
                  src={data.image}
                  alt={data.title}
                />
              </BoxIcon>
              <Text
                accessible
                inverted={false}
                textAlign="center"
                type="p"
                customProperties={{ id: "title" }}
                // onClick={() => handleButtonClick(data.title, data.url, data.image)}
              >
                {ReactHtmlParser(data.title)}
              </Text>
            </MobileIcons>
          </Link>
        ))}
        </FeaturesIcons>
    </MobileContainer>
  );
}
